import { unique } from '@front-app/util/array';

export function getAsArray(x: (string | null)[] | undefined | string): string[] {
	if (x === undefined) {
		return [];
	}
	if (Array.isArray(x)) {
		return unique(x).filter((_: string | null) => _ !== null) as string[];
	}
	return [x];
}

/**
 * Gets the first result for a parameter that might be passed as an array or
 * csv value
 */
export const getSingleParam = (val: string | (string | null)[]): string => {
	if (Array.isArray(val)) {
		return val?.[0] || '';
	}
	return val?.split(',')[0] || '';
};
